import React from 'react'

function AddComponent({label,inputText,handleClick,handleChange,placeholder,buttonlabel}) {
  return (
      <div>
          
          <label className="label">{label }</label>

                <div className="field has-addons">
                    <div className="control">
                        <input className="input" type="text"  placeholder={placeholder} value={inputText} onChange={handleChange} />
                    </div>
                    <div className="control">
                  <button onClick={handleClick} className="button is-primary">{buttonlabel?buttonlabel:label }</button>
                    </div>
                </div>
            </div>
    
  )
}

export default AddComponent